export default function useFlatNo(property: string, street: string) {
  let data = property.split(",");

  if (data && data.length > 0) {
    let flatUnitcheckingList = ['apartment', 'flat', 'unit', 'room', '/'];
    let streetCheckingList = ['/'];
    let result = flatUnitcheckingList.filter(item => data[0].toLowerCase().indexOf(item) != -1).length > 0 ? data[0].trim() : '';

    if (result == '' && street !== '') {
      let streetData = street.split(" ");

      if (streetData && street.length > 0) {
        result = streetCheckingList.filter(item => streetData[0].toLowerCase().indexOf(item) != -1).length > 0 ? streetData[0].trim() : '';

        let checkUnitData = result.split('/');
        if (checkUnitData && checkUnitData.length > 1) {
          result = checkUnitData[1];
        }
      }
    }
    return result;
  } else {
    return '';
  }
}
